export default __webpack_public_path__ + "static/media/flag-ch.f8d79619.svg";